import React from 'react';
import { useTranslation } from 'react-i18next';
import { openModal, IModal } from '.';
import { Button } from 'components/parts';

interface ConfirmParams {
  title?: any;
  description?: any;
  /** Default: false */
  isCloseOnly?: boolean;
}

function ConfirmModal(props: IModal<ConfirmParams>) {
  const { t } = useTranslation();
  const { modalRef } = props;

  return (
    <div className='confirm-modal'>
      <div className='modal-content'>
        <div className='modal-header'>
          <div className='modal-title h4'>{props.data?.title}</div>
        </div>
        <div className='modal-body'>
          <div className='confirm-message'>{props.data?.description}</div>
        </div>
        {!props.data?.isCloseOnly && (
          <div className='modal-footer'>
            <Button type='button' theme='danger' className='h-mr-8' onClick={() => modalRef.close(false)}>
              {t('common.btn.cancel')}
            </Button>
            <Button type='submit' onClick={() => modalRef.close(true)}>
              {t('common.btn.confirm')}
            </Button>
          </div>
        )}

        {props.data?.isCloseOnly && (
          <div className='modal-footer'>
            <Button type='button' theme='danger' onClick={() => modalRef.close(false)}>
              {t('common.btn.close')}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

export function dialogConfirm(params: ConfirmParams) {
  return openModal(ConfirmModal, { closeButton: false, className: 'modal-confirm-wrap', data: params }).afterClosed();
}
